// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Button,
//     Container,
//     Typography,
//     Paper,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     TextField,
//     Snackbar,
//     Alert,
//     DialogContentText,
//     MenuItem,
//     Select,
//     FormControl,
//     InputLabel,
//     Chip,
//     IconButton,
//     Tooltip,
//     Card,
//     CardMedia,
//     CardContent
// } from '@mui/material';
// import { Add, Visibility, Download, Delete, Edit, Info, Close, Image, Lock, LockOpen, SwapVert } from '@mui/icons-material';
// import { format } from 'date-fns';
// import { useNavigate, useParams } from 'react-router-dom';
// import { deleteExam, getAllExamsOfBatch, updateExamStatus } from 'helpers/exam_helper';
// import { toast } from 'react-toastify';
// import { CREATE_EXAM, DOWNLOAD_EXAM_REPORT } from 'helpers/url_helper';
// import { CircularProgress } from '@material-ui/core';

// // Import your image - adjust the path based on your file structure
// import singleImage from '../../../assets/images/product/qrcode_myExam.png';

// const ExamList = () => {
//     const [exams, setExams] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [openCreateDialog, setOpenCreateDialog] = useState(false);
//     const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
//     const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
//     const [errorMessage, setErrorMessage] = useState('');
//     const [selectedFile, setSelectedFile] = useState(null);
//     const params = useParams();
//     const navigate = useNavigate();
    
//     // Image popup dialog state
//     const [openImageDialog, setOpenImageDialog] = useState(false);

//     // Form state
//     const [formData, setFormData] = useState({
//         id: null,
//         title: '',
//         description: '',
//         durationMinutes: 30,
//         maxWarnings: 3,
//         saveLiveVideo: false,
//         saveScreenShare: false,
//         lastAttemptDate: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
//         batchId: params.id,
//         status: 'unlocked',
//         examType: 'none' // New field: 'none', 'preTest', 'postTest'
//     });

//     const [openConfirmModal, setOpenConfirmModal] = useState(false);
//     const [examToDeleteId, setExamToDeleteId] = useState(null);
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [selectedExamId, setSelectedExamId] = useState(null);
//     const [fileError, setFileError] = useState('');
//     const [descriptionHelpText, setDescriptionHelpText] = useState('');
//     const [updatingStatus, setUpdatingStatus] = useState(null);

//     useEffect(() => {
//         fetchExams();
//     }, []);

//     // Update description help text when description changes
//     useEffect(() => {
//         const desc = formData.description;
//         if (!desc) {
//             setDescriptionHelpText('Enter question count (e.g., "10 questions", "20 questions")');
//             return;
//         }

//         const match = desc.match(/(\d+)\s*(?:questions?|Questions?|q|Q|out of)/i);
//         if (match) {
//             const questionCount = parseInt(match[1]);
//             setDescriptionHelpText(`System will randomly select ${questionCount} questions from Excel file. Excel must have at least ${questionCount} questions.`);
//         } else {
//             setDescriptionHelpText('Enter question count (e.g., "10 questions", "20 questions")');
//         }
//     }, [formData.description]);

//     // Safe date formatting function
//     const formatExamDate = (dateArray) => {
//         if (!dateArray || !Array.isArray(dateArray) || dateArray.length < 5) {
//             return 'Date not set';
//         }
        
//         try {
//             const [year, month, day, hours, minutes] = dateArray;
//             if ([year, month, day, hours, minutes].some(val => isNaN(val))) {
//                 return 'Invalid Date';
//             }
//             const date = new Date(year, month - 1, day, hours, minutes);
            
//             if (isNaN(date.getTime())) {
//                 return 'Invalid Date';
//             }
            
//             return format(date, 'MMM dd, yyyy HH:mm');
//         } catch (error) {
//             console.error('Error formatting date:', error);
//             return 'Invalid Date';
//         }
//     };

//     // Extract question count from description for display
//     const getQuestionInfo = (description) => {
//         if (!description) return { text: 'No questions specified', count: null };
        
//         const match = description.match(/(\d+)\s*(?:questions?|Questions?|q|Q|out of)/i);
//         if (match) {
//             const count = parseInt(match[1]);
//             return { text: `${count} questions`, count };
//         }
        
//         return { text: 'No questions specified', count: null };
//     };

//     // Get status chip color and icon
//     const getStatusInfo = (status) => {
//         const statusValue = status?.toString()?.toLowerCase();
//         if (statusValue === 'locked') {
//             return {
//                 color: 'error',
//                 label: 'Locked',
//                 icon: <Lock fontSize="small" />
//             };
//         } else {
//             return {
//                 color: 'success',
//                 label: 'Unlocked',
//                 icon: <LockOpen fontSize="small" />
//             };
//         }
//     };

//     // Get exam type display info
//     const getExamTypeInfo = (examType) => {
//         switch(examType) {
//             case 'preTest':
//                 return {
//                     label: 'Pre-Test',
//                     color: 'primary',
//                     icon: '📝'
//                 };
//             case 'postTest':
//                 return {
//                     label: 'Post-Test',
//                     color: 'secondary',
//                     icon: '📋'
//                 };
//             default:
//                 return {
//                     label: 'Regular',
//                     color: 'default',
//                     icon: '📚'
//                 };
//         }
//     };

//     const fetchExams = async () => {
//         try {
//             setLoading(true);
//             const data = await getAllExamsOfBatch(params.id);
//             if (data?.success) {
//                 console.log('Fetched exams:', data.result);
//                 const examsWithStatus = Array.isArray(data?.result) ? data.result.map(exam => ({
//                     ...exam,
//                     status: exam.status || 'unlocked',
//                     examType: exam.examType || 'none'
//                 })) : [];
//                 setExams(examsWithStatus);
//             } else {
//                 setErrorMessage('Failed to load exams');
//                 toast.error(data?.message || 'Failed to load exams');
//                 setOpenErrorSnackbar(true);
//             }
//         } catch (error) {
//             console.error('Error fetching exams:', error);
//             setErrorMessage('Failed to load exams');
//             setOpenErrorSnackbar(true);
//             setExams([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Generate full exam title with prefix
//     const generateFullTitle = (baseTitle, examType) => {
//         if (!baseTitle) return '';
        
//         const trimmedTitle = baseTitle.trim();
        
//         switch(examType) {
//             case 'preTest':
//                 return `Pre-Test (${trimmedTitle})`;
//             case 'postTest':
//                 return `Post-Test (${trimmedTitle})`;
//             default:
//                 return trimmedTitle;
//         }
//     };

//     // Extract base title from full title (for editing)
//     const extractBaseTitle = (fullTitle, examType) => {
//         if (!fullTitle) return '';
        
//         const trimmedTitle = fullTitle.trim();
        
//         switch(examType) {
//             case 'preTest':
//                 // Remove "Pre-Test (" prefix and ")" suffix
//                 if (trimmedTitle.startsWith('Pre-Test (') && trimmedTitle.endsWith(')')) {
//                     return trimmedTitle.substring(10, trimmedTitle.length - 1);
//                 }
//                 return trimmedTitle;
//             case 'postTest':
//                 // Remove "Post-Test (" prefix and ")" suffix
//                 if (trimmedTitle.startsWith('Post-Test (') && trimmedTitle.endsWith(')')) {
//                     return trimmedTitle.substring(11, trimmedTitle.length - 1);
//                 }
//                 return trimmedTitle;
//             default:
//                 return trimmedTitle;
//         }
//     };

//     const handleCreateOrUpdateExam = async () => {
//         try {
//             setLoading(true);
//             setFileError('');
            
//             // Basic validation - only for required fields
//             if (!isEditMode && !selectedFile) {
//                 setFileError('Please upload a questions file');
//                 throw new Error('Please upload a questions file');
//             }

//             if (!formData.title?.trim()) {
//                 throw new Error('Exam title is required');
//             }

//             // Generate full title with prefix based on exam type
//             const fullTitle = generateFullTitle(formData.title, formData.examType);

//             // Use FormData for multipart upload
//             const formDataToSend = new FormData();
            
//             // Create examDTO as JSON string
//             const examDTO = {
//                 id: isEditMode ? formData.id : null,
//                 title: fullTitle, // Store the full title with prefix
//                 description: formData.description?.trim() || '',
//                 durationMinutes: parseInt(formData.durationMinutes) || 30,
//                 maxWarnings: parseInt(formData.maxWarnings) || 3,
//                 saveLiveVideo: Boolean(formData.saveLiveVideo),
//                 saveScreenShare: Boolean(formData.saveScreenShare),
//                 lastAttemptDate: formData.lastAttemptDate,
//                 batchId: parseInt(formData.batchId),
//                 status: formData.status,
//                 examType: formData.examType // Store the exam type
//             };

//             console.log(`${isEditMode ? 'Updating' : 'Creating'} exam with data:`, examDTO);
//             console.log('Generated full title:', fullTitle);

//             // Append examDTO as JSON
//             formDataToSend.append('examDTO', 
//                 new Blob([JSON.stringify(examDTO)], {
//                     type: 'application/json'
//                 })
//             );

//             // Append questions file
//             if (selectedFile) {
//                 formDataToSend.append('questionsFile', selectedFile);
//             }

//             // Use the helper function for API call
//             const response = await fetch(CREATE_EXAM, {
//                 method: 'POST',
//                 body: formDataToSend,
//             });

//             const data = await response.json();

//             if (data?.success) {
//                 toast.success(`Exam ${isEditMode ? 'Updated' : 'Created'} Successfully`);
//                 setOpenSuccessSnackbar(true);
//                 fetchExams();
//                 setOpenCreateDialog(false);
//                 resetForm();
//                 setIsEditMode(false);
//                 setSelectedExamId(null);
//             } else {
//                 throw new Error(data?.message || `Failed to ${isEditMode ? 'update' : 'create'} exam`);
//             }

//         } catch (error) {
//             console.error(`Error ${isEditMode ? 'updating' : 'creating'} exam:`, error);
//             let errorMsg = `Failed to ${isEditMode ? 'update' : 'create'} exam`;
            
//             if (error.response?.data) {
//                 if (typeof error.response.data === 'string') {
//                     errorMsg = error.response.data;
//                 } else if (error.response.data.message) {
//                     errorMsg = error.response.data.message;
//                 }
//             } else if (error.message) {
//                 errorMsg = error.message;
//             }
            
//             if (errorMsg.toLowerCase().includes('excel file has only') || 
//                 errorMsg.toLowerCase().includes('upload excel with at least')) {
//                 setFileError(errorMsg);
//             }
            
//             setErrorMessage(errorMsg);
//             setOpenErrorSnackbar(true);
//             toast.error(errorMsg);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Toggle status with proper error handling
//     const handleToggleStatus = async (examId, currentStatus) => {
//         if (!examId) {
//             toast.error('Invalid exam ID');
//             return;
//         }

//         try {
//             setUpdatingStatus(examId);
            
//             // Determine new status
//             const newStatus = currentStatus === 'locked' ? 'unlocked' : 'locked';
            
//             console.log(`Toggling status for exam ${examId} from ${currentStatus} to ${newStatus}`);

//             const response = await updateExamStatus(examId, newStatus);

//             console.log('Update status response:', response);

//             if (response?.success) {
//                 toast.success(`Status updated to ${newStatus}`);
                
//                 setExams(prevExams => 
//                     prevExams.map(exam => 
//                         exam.id === examId 
//                             ? { ...exam, status: newStatus }
//                             : exam
//                     )
//                 );
//             } else if (response?.data?.success) {
//                 toast.success(`Status updated to ${newStatus}`);
                
//                 setExams(prevExams => 
//                     prevExams.map(exam => 
//                         exam.id === examId 
//                             ? { ...exam, status: newStatus }
//                             : exam
//                     )
//                 );
//             } else {
//                 const errorMsg = response?.data?.message || 
//                                response?.message || 
//                                'Failed to update status';
//                 throw new Error(errorMsg);
//             }

//         } catch (error) {
//             console.error('Error toggling status:', error);
//             let errorMsg = 'Failed to update status';
            
//             if (error.response?.data?.message) {
//                 errorMsg = error.response.data.message;
//             } else if (error.response?.data) {
//                 if (typeof error.response.data === 'string') {
//                     try {
//                         const parsed = JSON.parse(error.response.data);
//                         errorMsg = parsed.message || errorMsg;
//                     } catch {
//                         errorMsg = error.response.data;
//                     }
//                 }
//             } else if (error.message) {
//                 errorMsg = error.message;
//             }
            
//             console.warn(`Status toggle failed for exam ${examId}:`, errorMsg);
//             toast.error(`Update failed: ${errorMsg}`);
            
//         } finally {
//             setUpdatingStatus(null);
//         }
//     };

//     const resetForm = () => {
//         setFormData({
//             id: null,
//             title: '',
//             description: '',
//             durationMinutes: 30,
//             maxWarnings: 3,
//             saveLiveVideo: false,
//             saveScreenShare: false,
//             lastAttemptDate: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
//             batchId: params.id,
//             status: 'unlocked',
//             examType: 'none'
//         });
//         setSelectedFile(null);
//         setFileError('');
//         setIsEditMode(false);
//         setSelectedExamId(null);
//         setDescriptionHelpText('Enter question count (e.g., "10 questions", "20 questions")');
//     };

//     const handleEditExam = (exam) => {
//         if (!exam) return;
        
//         setIsEditMode(true);
//         setSelectedExamId(exam.id);
        
//         // Convert date array to datetime-local format
//         let lastAttemptDate = format(new Date(), "yyyy-MM-dd'T'HH:mm");
//         if (exam.lastAttemptDate && Array.isArray(exam.lastAttemptDate) && exam.lastAttemptDate.length >= 5) {
//             const [year, month, day, hours, minutes] = exam.lastAttemptDate;
//             const date = new Date(year, month - 1, day, hours, minutes);
//             lastAttemptDate = format(date, "yyyy-MM-dd'T'HH:mm");
//         }
        
//         // Extract base title from full title
//         const baseTitle = extractBaseTitle(exam.title, exam.examType);
        
//         setFormData({
//             id: exam.id,
//             title: baseTitle, // Set the base title without prefix
//             description: exam.description || '',
//             durationMinutes: exam.durationMinutes || 30,
//             maxWarnings: exam.maxWarnings || 3,
//             saveLiveVideo: exam.saveLiveVideo || false,
//             saveScreenShare: exam.saveScreenShare || false,
//             lastAttemptDate: lastAttemptDate,
//             batchId: params.id,
//             status: exam.status || 'unlocked',
//             examType: exam.examType || 'none'
//         });
        
//         console.log('Editing exam:', {
//             fullTitle: exam.title,
//             baseTitle: baseTitle,
//             examType: exam.examType
//         });
        
//         setSelectedFile(null);
//         setFileError('');
//         setOpenCreateDialog(true);
//     };

//     const handleFileChange = (event) => {
//         const file = event.target.files?.[0] || null;
//         setSelectedFile(file);
//         setFileError('');
        
//         if (file) {
//             const validTypes = ['.xlsx', '.xls'];
//             const fileExt = '.' + file.name.split('.').pop().toLowerCase();
            
//             if (!validTypes.includes(fileExt)) {
//                 setFileError('Please upload only Excel files (.xlsx, .xls)');
//                 setSelectedFile(null);
//                 event.target.value = '';
//             }
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: type === 'checkbox' ? checked : value
//         }));
        
//         if (name === 'description') {
//             setFileError('');
//         }
//     };

//     const handleProctoringClick = (examId) => {
//         if (examId) {
//             navigate(`/proctor-dashboard/${examId}`);
//         } else {
//             toast.error('Invalid exam ID');
//         }
//     };

//     const handleDownloadReport = async (examId) => {
//         if (!examId) {
//             toast.error('Invalid exam ID');
//             return;
//         }

//         try {
//             setLoading(true);

//             const authUser = localStorage.getItem('authUser');
//             let organizationId = null;

//             if (authUser) {
//                 try {
//                     const parsedUser = JSON.parse(authUser);
//                     organizationId = parsedUser?.organizationId || null;
//                 } catch (parseError) {
//                     console.error('Error parsing authUser:', parseError);
//                 }
//             }

//             const response = await fetch(`${DOWNLOAD_EXAM_REPORT}${examId}`, {
//                 method: 'GET',
//                 headers: {
//                     "X-Organization-ID": organizationId,
//                 }
//             });

//             if (!response.ok) {
//                 throw new Error('Failed to download report');
//             }

//             const blob = await response.blob();
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'exam_report.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
            
//         } catch (error) {
//             console.log('Download error:', error);
//             toast.error(error?.response?.data?.message || "Failed to download report");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDeleteExam = async (examId) => {
//         if (!examId) {
//             toast.error('Invalid exam ID');
//             return;
//         }

//         try {
//             setLoading(true);
//             const data = await deleteExam(examId);
//             if (data?.success) {
//                 toast.success(data.message || 'Exam deleted successfully');
//                 fetchExams();
//             } else {
//                 toast.error(data?.message || 'Failed to delete exam');
//             }
//         } catch (error) {
//             console.log('Delete error:', error);
//             toast.error(error?.response?.data?.message || "Something went wrong");
//         } finally {
//             setLoading(false);
//         }
//     }

//     const handleOpenConfirmModal = (examId) => {
//         if (examId) {
//             setExamToDeleteId(examId);
//             setOpenConfirmModal(true);
//         }
//     };

//     const handleCloseConfirmModal = () => {
//         setOpenConfirmModal(false);
//         setExamToDeleteId(null);
//     };

//     const handleConfirmDelete = () => {
//         if (examToDeleteId) {
//             handleDeleteExam(examToDeleteId);
//         }
//         handleCloseConfirmModal();
//     };

//     const clearSelectedFile = () => {
//         setSelectedFile(null);
//         setFileError('');
//         const fileInput = document.getElementById('questions-file');
//         if (fileInput) {
//             fileInput.value = '';
//         }
//     };

//     const downloadImage = () => {
//         const link = document.createElement('a');
//         link.href = singleImage;
//         link.download = 'exam-qr-code.png';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     return (
//         <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
//                 <Box>
//                     <Typography variant="h4" component="h1" gutterBottom>
//                         Exams Management
//                     </Typography>
//                     <Typography variant="body1" color="text.secondary">
//                         Create and manage exams for this batch
//                     </Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', gap: 2 }}>
//                     <Button
//                         variant="outlined"
//                         color="secondary"
//                         startIcon={<Image />}
//                         onClick={() => setOpenImageDialog(true)}
//                         disabled={loading}
//                         size="large"
//                         sx={{
//                             textTransform: 'none',
//                             fontWeight: 500
//                         }}
//                     >
//                         View Exam QR
//                     </Button>
//                     <Button
//                         variant="contained"
//                         color="primary"
//                         startIcon={<Add />}
//                         onClick={() => {
//                             resetForm();
//                             setOpenCreateDialog(true);
//                         }}
//                         disabled={loading}
//                         size="large"
//                     >
//                         Create New Exam
//                     </Button>
//                 </Box>
//             </Box>

//             {/* Info Card */}
//             <Paper sx={{ p: 3, mb: 3, bgcolor: 'info.light', color: 'info.contrastText' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                     <Info />
//                     <Typography variant="subtitle1" fontWeight="bold">
//                         How it works:
//                     </Typography>
//                 </Box>
//                 <Typography variant="body2">
//                     • Description must specify question count (e.g., "10 questions", "20 questions")<br/>
//                     • Upload Excel file with questions (can have more questions than needed)<br/>
//                     • System will randomly select the required number of questions from Excel<br/>
//                     • <strong>Exam Type:</strong> Select Pre-Test or Post-Test to automatically prefix the exam title<br/>
//                     • <strong>Status:</strong> Click on status chip to toggle between Locked/Unlocked<br/>
//                     • <strong>Click "View Image" button to see the exam QR code/image</strong>
//                 </Typography>
//             </Paper>

//             {loading && !exams.length ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
//                     <CircularProgress size={60} />
//                 </Box>
//             ) : (
//                 <TableContainer component={Paper} elevation={3}>
//                     <Table>
//                         <TableHead>
//                             <TableRow sx={{ bgcolor: 'primary.main' }}>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Title</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Type</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Description</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Questions</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Duration (mins)</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Last Attempt Date</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Proctoring</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Report</TableCell>
//                                 <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {Array.isArray(exams) && exams.length > 0 ? (
//                                 exams.map((exam) => {
//                                     const questionInfo = getQuestionInfo(exam.description);
//                                     const statusInfo = getStatusInfo(exam.status);
//                                     const examTypeInfo = getExamTypeInfo(exam.examType);
//                                     const isUpdating = updatingStatus === exam.id;
                                    
//                                     return (
//                                         <TableRow 
//                                             key={exam.id}
//                                             hover
//                                             sx={{ 
//                                                 '&:hover': { bgcolor: 'action.hover' },
//                                                 '&:last-child td, &:last-child th': { border: 0 }
//                                             }}
//                                         >
//                                             <TableCell>
//                                                 <Typography fontWeight="medium">{exam.title || 'N/A'}</Typography>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Chip 
//                                                     label={examTypeInfo.label}
//                                                     color={examTypeInfo.color}
//                                                     size="small"
//                                                     icon={<span>{examTypeInfo.icon}</span>}
//                                                 />
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Typography variant="body2" sx={{ maxWidth: '200px' }}>
//                                                     {exam.description || 'No description'}
//                                                 </Typography>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Chip 
//                                                     label={questionInfo.text}
//                                                     color={questionInfo.count ? "primary" : "default"}
//                                                     size="small"
//                                                     variant="outlined"
//                                                 />
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Tooltip title={`Click to toggle status. Current: ${statusInfo.label}`}>
//                                                     <Box sx={{ display: 'inline-block' }}>
//                                                         <Chip 
//                                                             icon={isUpdating ? <SwapVert fontSize="small" /> : statusInfo.icon}
//                                                             label={isUpdating ? 'Updating...' : statusInfo.label}
//                                                             color={statusInfo.color}
//                                                             size="small"
//                                                             variant="filled"
//                                                             onClick={() => handleToggleStatus(exam.id, exam.status)}
//                                                             disabled={isUpdating}
//                                                             sx={{
//                                                                 fontWeight: 'medium',
//                                                                 '& .MuiChip-icon': {
//                                                                     ml: 0.5
//                                                                 },
//                                                                 cursor: isUpdating ? 'default' : 'pointer',
//                                                                 '&:hover:not(:disabled)': {
//                                                                     opacity: 0.9,
//                                                                     transform: 'scale(1.05)',
//                                                                     transition: 'transform 0.2s'
//                                                                 }
//                                                             }}
//                                                         />
//                                                     </Box>
//                                                 </Tooltip>
//                                                 {exam.status === 'locked' && (
//                                                     <Typography variant="caption" color="error" sx={{ ml: 1, display: 'block', mt: 0.5 }}>
//                                                         Students cannot access this exam
//                                                     </Typography>
//                                                 )}
//                                                 {exam.status === 'unlocked' && (
//                                                     <Typography variant="caption" color="success" sx={{ ml: 1, display: 'block', mt: 0.5 }}>
//                                                         Students can access this exam
//                                                     </Typography>
//                                                 )}
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Chip 
//                                                     label={`${exam.durationMinutes || 'N/A'} mins`}
//                                                     size="small"
//                                                 />
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Typography variant="body2">
//                                                     {formatExamDate(exam.lastAttemptDate)}
//                                                 </Typography>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Tooltip title="Open proctoring dashboard">
//                                                     <Button
//                                                         variant="outlined"
//                                                         color="primary"
//                                                         size="small"
//                                                         startIcon={<Visibility />}
//                                                         onClick={() => handleProctoringClick(exam.id)}
//                                                         sx={{
//                                                             textTransform: 'none',
//                                                             fontSize: '0.875rem'
//                                                         }}
//                                                     >
//                                                         Proctor
//                                                     </Button>
//                                                 </Tooltip>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Tooltip title="Download exam report">
//                                                     <Button
//                                                         variant="outlined"
//                                                         color="secondary"
//                                                         size="small"
//                                                         startIcon={<Download />}
//                                                         onClick={() => handleDownloadReport(exam.id)}
//                                                         sx={{
//                                                             textTransform: 'none',
//                                                             fontSize: '0.875rem'
//                                                         }}
//                                                     >
//                                                         Report
//                                                     </Button>
//                                                 </Tooltip>
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Box sx={{ display: 'flex', gap: 1 }}>
//                                                     <Tooltip title="Edit exam">
//                                                         <Button
//                                                             variant="outlined"
//                                                             color="primary"
//                                                             size="small"
//                                                             startIcon={<Edit />}
//                                                             onClick={() => handleEditExam(exam)}
//                                                             sx={{
//                                                                 textTransform: 'none',
//                                                                 fontSize: '0.875rem'
//                                                             }}
//                                                         >
//                                                             Edit
//                                                         </Button>
//                                                     </Tooltip>
//                                                     <Tooltip title="Delete exam">
//                                                         <Button
//                                                             variant="outlined"
//                                                             color="error"
//                                                             size="small"
//                                                             startIcon={<Delete />}
//                                                             onClick={() => handleOpenConfirmModal(exam.id)}
//                                                             sx={{
//                                                                 textTransform: 'none',
//                                                                 fontSize: '0.875rem'
//                                                             }}
//                                                         >
//                                                             Delete
//                                                         </Button>
//                                                     </Tooltip>
//                                                 </Box>
//                                             </TableCell>
//                                         </TableRow>
//                                     );
//                                 })
//                             ) : (
//                                 <TableRow>
//                                     <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
//                                         <Box sx={{ textAlign: 'center' }}>
//                                             <Typography variant="h6" color="text.secondary" gutterBottom>
//                                                 No exams found
//                                             </Typography>
//                                             <Typography variant="body2" color="text.secondary" gutterBottom>
//                                                 Create your first exam by clicking the "Create New Exam" button
//                                             </Typography>
//                                             <Button
//                                                 variant="contained"
//                                                 color="primary"
//                                                 startIcon={<Add />}
//                                                 onClick={() => {
//                                                     resetForm();
//                                                     setOpenCreateDialog(true);
//                                                 }}
//                                                 sx={{ mt: 2 }}
//                                             >
//                                                 Create First Exam
//                                             </Button>
//                                         </Box>
//                                     </TableCell>
//                                 </TableRow>
//                             )}
//                         </TableBody>
//                     </Table>
                    
//                     {/* Confirm Delete Dialog */}
//                     <Dialog
//                         open={openConfirmModal}
//                         onClose={handleCloseConfirmModal}
//                         aria-labelledby="alert-dialog-title"
//                         aria-describedby="alert-dialog-description"
//                     >
//                         <DialogTitle id="alert-dialog-title">
//                             {"Confirm Deletion"}
//                         </DialogTitle>
//                         <DialogContent>
//                             <DialogContentText id="alert-dialog-description">
//                                 Are you sure you want to delete this exam? This action cannot be undone and will delete all related data including student attempts.
//                             </DialogContentText>
//                         </DialogContent>
//                         <DialogActions>
//                             <Button onClick={handleCloseConfirmModal} color="primary">
//                                 Cancel
//                             </Button>
//                             <Button onClick={handleConfirmDelete} color="error" variant="contained" autoFocus>
//                                 Delete Exam
//                             </Button>
//                         </DialogActions>
//                     </Dialog>
//                 </TableContainer>
//             )}

//             {/* Image Popup Dialog */}
//             <Dialog
//                 open={openImageDialog}
//                 onClose={() => setOpenImageDialog(false)}
//                 maxWidth="md"
//                 fullWidth
//                 sx={{
//                     '& .MuiDialog-paper': {
//                         maxHeight: '90vh',
//                         margin: 0
//                     }
//                 }}
//             >
//                 <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Typography variant="h6">
//                             Exam QR Code / Image
//                         </Typography>
//                         <IconButton 
//                             onClick={() => setOpenImageDialog(false)}
//                             sx={{ color: 'white' }}
//                         >
//                             <Close />
//                         </IconButton>
//                     </Box>
//                 </DialogTitle>
//                 <DialogContent dividers sx={{ pt: 3 }}>
//                     <Box sx={{ textAlign: 'center' }}>
//                         <Card sx={{ maxWidth: 500, mx: 'auto', mb: 3 }}>
//                             <CardMedia
//                                 component="img"
//                                 image={singleImage}
//                                 alt="Exam QR Code"
//                                 sx={{ 
//                                     width: '100%', 
//                                     height: 'auto',
//                                     maxHeight: 400,
//                                     objectFit: 'contain',
//                                     p: 2
//                                 }}
//                             />
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Exam QR Code
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary" paragraph>
//                                     This QR code/image is common for all exams. Students can scan this code to access their exams.
//                                 </Typography>
//                                 <Box sx={{ mt: 2 }}>
//                                     <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
//                                         • Share this image with students<br/>
//                                         • Print for classroom display<br/>
//                                         • Include in exam instructions
//                                     </Typography>
//                                 </Box>
//                             </CardContent>
//                         </Card>

//                         {/* Instructions */}
//                         <Paper sx={{ p: 3, mb: 3, bgcolor: 'grey.50' }}>
//                             <Typography variant="subtitle1" gutterBottom fontWeight="bold">
//                                 How to use:
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" paragraph>
//                                 1. <strong>For Students:</strong> Scan the QR code with a mobile device camera or QR scanner app
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" paragraph>
//                                 2. <strong>For Instructors:</strong> Display this image during exam sessions for easy access
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" paragraph>
//                                 3. <strong>For Printed Materials:</strong> Include this QR code in exam handouts and announcements
//                             </Typography>
//                             <Alert severity="info" sx={{ mt: 2 }}>
//                                 <Typography variant="body2">
//                                     <strong>Note:</strong> This is a common QR code for all exams. It provides quick access to the exam portal.
//                                 </Typography>
//                             </Alert>
//                         </Paper>
//                     </Box>
//                 </DialogContent>
//                 <DialogActions sx={{ p: 2, bgcolor: 'grey.50' }}>
//                     <Button 
//                         onClick={() => setOpenImageDialog(false)}
//                         color="inherit"
//                     >
//                         Close
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Create/Edit Exam Dialog */}
//             <Dialog
//                 open={openCreateDialog}
//                 onClose={() => {
//                     setOpenCreateDialog(false);
//                     resetForm();
//                 }}
//                 fullWidth
//                 maxWidth="md"
//                 sx={{
//                     '& .MuiDialog-paper': {
//                         maxHeight: '90vh',
//                         margin: 0,
//                         overflowY: 'auto'
//                     }
//                 }}
//             >
//                 <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Typography variant="h6">
//                             {isEditMode ? 'Edit Exam' : 'Create New Exam'}
//                         </Typography>
//                         <IconButton 
//                             onClick={() => {
//                                 setOpenCreateDialog(false);
//                                 resetForm();
//                             }}
//                             sx={{ color: 'white' }}
//                         >
//                             <Close />
//                         </IconButton>
//                     </Box>
//                 </DialogTitle>
//                 <DialogContent dividers sx={{ pt: 3 }}>
//                     <Box component="form" sx={{ mt: 1 }}>
//                         {/* Exam Title */}
//                         <TextField
//                             margin="normal"
//                             required
//                             fullWidth
//                             label="Exam Title"
//                             name="title"
//                             value={formData.title}
//                             onChange={handleInputChange}
//                             variant="outlined"
//                             size="small"
//                             helperText={formData.examType !== 'none' ? 
//                                 `Full title will be: ${generateFullTitle(formData.title, formData.examType)}` : 
//                                 'Enter the base title for the exam'}
//                         />
                        
//                         {/* Exam Type Dropdown */}
//                         <FormControl fullWidth margin="normal" size="small">
//                             <InputLabel>Exam Type</InputLabel>
//                             <Select
//                                 name="examType"
//                                 value={formData.examType}
//                                 onChange={handleInputChange}
//                                 label="Exam Type"
//                                 variant="outlined"
//                             >
//                                 <MenuItem value="none">
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <span>📚</span>
//                                         <Typography>Regular</Typography>
//                                         <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                                             (No prefix)
//                                         </Typography>
//                                     </Box>
//                                 </MenuItem>
//                                 <MenuItem value="preTest">
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <span>📝</span>
//                                         <Typography>Pre-Test</Typography>
//                                         <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                                             (Adds "Pre-Test" prefix)
//                                         </Typography>
//                                     </Box>
//                                 </MenuItem>
//                                 <MenuItem value="postTest">
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <span>📋</span>
//                                         <Typography>Post-Test</Typography>
//                                         <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                                             (Adds "Post-Test" prefix)
//                                         </Typography>
//                                     </Box>
//                                 </MenuItem>
//                             </Select>
//                         </FormControl>
                        
//                         {/* Description */}
//                         <TextField
//                             margin="normal"
//                             fullWidth
//                             label="Description & Question Count"
//                             name="description"
//                             multiline
//                             rows={2}
//                             value={formData.description}
//                             onChange={handleInputChange}
//                             placeholder='Example: "10 questions" or "20 questions"'
//                             helperText={descriptionHelpText}
//                             variant="outlined"
//                             size="small"
//                             InputProps={{
//                                 endAdornment: formData.description && (
//                                     <Tooltip title="Clear">
//                                         <IconButton 
//                                             size="small" 
//                                             onClick={() => setFormData(prev => ({...prev, description: ''}))}
//                                         >
//                                             <Close fontSize="small" />
//                                         </IconButton>
//                                     </Tooltip>
//                                 )
//                             }}
//                         />
                        
//                         {/* Status Selector */}
//                         <Box sx={{ mt: 2, mb: 2 }}>
//                             <FormControl fullWidth margin="normal" size="small">
//                                 <InputLabel>Exam Status</InputLabel>
//                                 <Select
//                                     name="status"
//                                     value={formData.status}
//                                     onChange={handleInputChange}
//                                     label="Exam Status"
//                                     variant="outlined"
//                                 >
//                                     <MenuItem value="unlocked">
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                             <LockOpen fontSize="small" color="success" />
//                                             <Typography>Unlocked</Typography>
//                                             <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                                                 (Students can access)
//                                             </Typography>
//                                         </Box>
//                                     </MenuItem>
//                                     <MenuItem value="locked">
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                             <Lock fontSize="small" color="error" />
//                                             <Typography>Locked</Typography>
//                                             <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                                                 (Students cannot access)
//                                             </Typography>
//                                         </Box>
//                                     </MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </Box>
                        
//                         {/* Duration and Warnings */}
//                         <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
//                             <TextField
//                                 margin="normal"
//                                 required
//                                 label="Duration (minutes)"
//                                 name="durationMinutes"
//                                 type="number"
//                                 value={formData.durationMinutes}
//                                 onChange={handleInputChange}
//                                 sx={{ minWidth: '200px', flex: 1 }}
//                                 variant="outlined"
//                                 size="small"
//                             />
//                             <TextField
//                                 margin="normal"
//                                 required
//                                 label="Max Warnings"
//                                 name="maxWarnings"
//                                 type="number"
//                                 value={formData.maxWarnings}
//                                 onChange={handleInputChange}
//                                 sx={{ minWidth: '200px', flex: 1 }}
//                                 variant="outlined"
//                                 size="small"
//                             />
//                         </Box>
                        
//                         {/* Last Attempt Date */}
//                         <Box sx={{ mt: 2 }}>
//                             <TextField
//                                 label="Last Attempt Date & Time"
//                                 type="datetime-local"
//                                 name="lastAttemptDate"
//                                 value={formData.lastAttemptDate}
//                                 onChange={handleInputChange}
//                                 fullWidth
//                                 margin="normal"
//                                 InputLabelProps={{
//                                     shrink: true,
//                                 }}
//                                 variant="outlined"
//                                 size="small"
//                             />
//                         </Box>
                        
//                         {/* Proctoring Options */}
//                         <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//                             <FormControl fullWidth margin="normal" size="small">
//                                 <InputLabel>Save Live Video</InputLabel>
//                                 <Select
//                                     name="saveLiveVideo"
//                                     value={formData.saveLiveVideo}
//                                     onChange={handleInputChange}
//                                     label="Save Live Video"
//                                     variant="outlined"
//                                 >
//                                     <MenuItem value={true}>Yes - Save video recording</MenuItem>
//                                     <MenuItem value={false}>No - Don't save video</MenuItem>
//                                 </Select>
//                             </FormControl>
//                             <FormControl fullWidth margin="normal" size="small">
//                                 <InputLabel>Save Screen Share</InputLabel>
//                                 <Select
//                                     name="saveScreenShare"
//                                     value={formData.saveScreenShare}
//                                     onChange={handleInputChange}
//                                     label="Save Screen Share"
//                                     variant="outlined"
//                                 >
//                                     <MenuItem value={true}>Yes - Save screen recording</MenuItem>
//                                     <MenuItem value={false}>No - Don't save screen</MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </Box>
                        
//                         {/* File Upload */}
//                         <Box sx={{ mt: 2, p: 2, border: '1px dashed', borderColor: fileError ? 'error.main' : 'grey.400', borderRadius: 1 }}>
//                             <Typography variant="subtitle1" gutterBottom fontWeight="bold">
//                                 {isEditMode ? 'Upload New Questions (Optional)' : 'Upload Questions (Excel File - Required)'}
//                             </Typography>
                            
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
//                                 <Button
//                                     variant="outlined"
//                                     component="label"
//                                     size="small"
//                                     startIcon={<Add />}
//                                 >
//                                     Choose Excel File
//                                     <input
//                                         accept=".xlsx,.xls"
//                                         id="questions-file"
//                                         type="file"
//                                         onChange={handleFileChange}
//                                         hidden
//                                         required={!isEditMode}
//                                     />
//                                 </Button>
                                
//                                 {selectedFile && (
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <Chip 
//                                             label={selectedFile.name}
//                                             onDelete={clearSelectedFile}
//                                             color="primary"
//                                             variant="outlined"
//                                         />
//                                         <Typography variant="body2" color="text.secondary">
//                                             ({Math.round(selectedFile.size / 1024)} KB)
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>
                            
//                             {fileError && (
//                                 <Alert severity="error" sx={{ mt: 2 }}>
//                                     {fileError}
//                                 </Alert>
//                             )}
                            
//                             {!selectedFile && !isEditMode && (
//                                 <Alert severity="warning" sx={{ mt: 2 }}>
//                                     Please select an Excel file (.xlsx, .xls) containing questions
//                                 </Alert>
//                             )}
                            
//                             {isEditMode && !selectedFile && (
//                                 <Alert severity="info" sx={{ mt: 2 }}>
//                                     No file selected. Existing questions will be retained.
//                                 </Alert>
//                             )}
                            
//                             <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
//                                 <strong>Excel Format:</strong> Columns should include: Question, Option1, Option2, Option3, Option4, CorrectAnswer (1-4)
//                             </Typography>
                            
//                             {!isEditMode && (
//                                 <Alert severity="info" sx={{ mt: 2 }}>
//                                     <strong>Note:</strong> System will randomly select questions from Excel based on description count.<br/>
//                                     Example: Description "10 questions" + Excel with 20 questions = 10 random questions saved
//                                 </Alert>
//                             )}
                            
//                             {isEditMode && (
//                                 <Alert severity="info" sx={{ mt: 2 }}>
//                                     <strong>Note:</strong> Upload new Excel file only if you want to change questions. 
//                                     System will randomly select questions based on new description count.
//                                 </Alert>
//                             )}
//                         </Box>
//                     </Box>
//                 </DialogContent>
//                 <DialogActions sx={{ p: 2, bgcolor: 'grey.50' }}>
//                     <Button 
//                         onClick={() => {
//                             setOpenCreateDialog(false);
//                             resetForm();
//                         }}
//                         color="inherit"
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         onClick={handleCreateOrUpdateExam}
//                         variant="contained"
//                         color="primary"
//                         disabled={loading || !formData.title.trim() || (!isEditMode && !selectedFile)}
//                         startIcon={loading ? <CircularProgress size={20} /> : null}
//                     >
//                         {loading ? 'Processing...' : (isEditMode ? 'Update Exam' : 'Create Exam')}
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Success Snackbar */}
//             <Snackbar
//                 open={openSuccessSnackbar}
//                 autoHideDuration={6000}
//                 onClose={() => setOpenSuccessSnackbar(false)}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//                 <Alert 
//                     onClose={() => setOpenSuccessSnackbar(false)} 
//                     severity="success" 
//                     sx={{ width: '100%' }}
//                     variant="filled"
//                 >
//                     {isEditMode ? '✓ Exam updated successfully!' : '✓ Exam created successfully!'}
//                 </Alert>
//             </Snackbar>

//             {/* Error Snackbar */}
//             <Snackbar
//                 open={openErrorSnackbar}
//                 autoHideDuration={6000}
//                 onClose={() => setOpenErrorSnackbar(false)}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//                 <Alert 
//                     onClose={() => setOpenErrorSnackbar(false)} 
//                     severity="error" 
//                     sx={{ width: '100%' }}
//                     variant="filled"
//                 >
//                     {errorMessage}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// };

// export default ExamList;









import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Container,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Snackbar,
    Alert,
    DialogContentText,
    FormControl,
    InputLabel,
    Chip,
    IconButton,
    Tooltip,
    Card,
    CardMedia,
    CardContent,
    Select,
    MenuItem,
    FormHelperText
} from '@mui/material';
import { Add, Visibility, Download, Delete, Edit, Info, Close, Image, Lock, LockOpen, SwapVert } from '@mui/icons-material';
import { format } from 'date-fns';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteExam, getAllExamsOfBatch, updateExamStatus } from 'helpers/exam_helper';
import { toast } from 'react-toastify';
import { CREATE_EXAM, DOWNLOAD_EXAM_REPORT } from 'helpers/url_helper';
import { CircularProgress } from '@material-ui/core';

// Import your image - adjust the path based on your file structure
import singleImage from '../../../assets/images/product/qrcode_myExam.png';

// Define users who can delete exams (same as attendance permission structure)
const ALLOW_DELETE_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager'];

const ExamList = () => {
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
    const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const params = useParams();
    const navigate = useNavigate();
    
    // Image popup dialog state
    const [openImageDialog, setOpenImageDialog] = useState(false);

    // User role and permissions state (same as Attendance component)
    const [userType, setUserType] = useState('');
    const [canDeleteExam, setCanDeleteExam] = useState(false);

    useEffect(() => {
        // Get user role from localStorage (same as Attendance component)
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        const currentUserType = authUser?.userType || '';
        setUserType(currentUserType);
        
        // Check if user can delete exams (Admin or Project Manager)
        setCanDeleteExam(ALLOW_DELETE_USERS.includes(currentUserType));
    }, []);

    // Form state
    const [formData, setFormData] = useState({
        id: null,
        title: '',
        description: '20 Questions', // Default description with 20 Questions
        durationMinutes: 30,
        maxWarnings: 3,
        saveLiveVideo: false,
        saveScreenShare: false,
        lastAttemptDate: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
        batchId: params.id,
        status: 'unlocked',
        examType: 'preTest' // Default to preTest
    });

    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [examToDeleteId, setExamToDeleteId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedExamId, setSelectedExamId] = useState(null);
    const [fileError, setFileError] = useState('');
    const [descriptionHelpText, setDescriptionHelpText] = useState('');
    const [updatingStatus, setUpdatingStatus] = useState(null);
    const [examTypeError, setExamTypeError] = useState('');

    useEffect(() => {
        fetchExams();
    }, []);

    // Update description help text when description changes
    useEffect(() => {
        const desc = formData.description;
        if (!desc) {
            setDescriptionHelpText('Enter number of questions (e.g., "10", "20", "30")');
            return;
        }

        // Extract number from description
        const match = desc.match(/(\d+)/);
        if (match) {
            const questionCount = parseInt(match[1]);
            setDescriptionHelpText(`System will randomly select ${questionCount} questions from Excel file. Excel must have at least ${questionCount} questions.`);
        } else {
            setDescriptionHelpText('Enter number of questions (e.g., "10", "20", "30")');
        }
    }, [formData.description]);

    // Safe date formatting function
    const formatExamDate = (dateArray) => {
        if (!dateArray || !Array.isArray(dateArray) || dateArray.length < 5) {
            return 'Date not set';
        }
        
        try {
            const [year, month, day, hours, minutes] = dateArray;
            if ([year, month, day, hours, minutes].some(val => isNaN(val))) {
                return 'Invalid Date';
            }
            const date = new Date(year, month - 1, day, hours, minutes);
            
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
            
            return format(date, 'MMM dd, yyyy HH:mm');
        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
        }
    };

    // Extract question count from description for display
    const getQuestionInfo = (description) => {
        if (!description) return { text: 'No questions specified', count: null };
        
        const match = description.match(/(\d+)/);
        if (match) {
            const count = parseInt(match[1]);
            return { text: `${count} questions`, count };
        }
        
        return { text: 'No questions specified', count: null };
    };

    // Get status chip color and icon
    const getStatusInfo = (status) => {
        const statusValue = status?.toString()?.toLowerCase();
        if (statusValue === 'locked') {
            return {
                color: 'error',
                label: 'Locked',
                icon: <Lock fontSize="small" />
            };
        } else {
            return {
                color: 'success',
                label: 'Unlocked',
                icon: <LockOpen fontSize="small" />
            };
        }
    };

    // Get exam type display info
    const getExamTypeInfo = (examType) => {
        if (examType === 'preTest') {
            return {
                label: 'Pre-Test',
                color: 'primary',
                icon: '📝'
            };
        } else if (examType === 'postTest') {
            return {
                label: 'Post-Test',
                color: 'secondary',
                icon: '📋'
            };
        }
        return {
            label: 'Regular',
            color: 'default',
            icon: '📚'
        };
    };

    const fetchExams = async () => {
        try {
            setLoading(true);
            const data = await getAllExamsOfBatch(params.id);
            if (data?.success) {
                console.log('Fetched exams:', data.result);
                const examsWithStatus = Array.isArray(data?.result) ? data.result.map(exam => ({
                    ...exam,
                    status: exam.status || 'unlocked',
                    examType: exam.examType || 'preTest'
                })) : [];
                setExams(examsWithStatus);
            } else {
                setErrorMessage('Failed to load exams');
                toast.error(data?.message || 'Failed to load exams');
                setOpenErrorSnackbar(true);
            }
        } catch (error) {
            console.error('Error fetching exams:', error);
            setErrorMessage('Failed to load exams');
            setOpenErrorSnackbar(true);
            setExams([]);
        } finally {
            setLoading(false);
        }
    };

    // Generate full exam title with prefix
    const generateFullTitle = (baseTitle, examType) => {
        if (!baseTitle) return '';
        
        const trimmedTitle = baseTitle.trim();
        
        if (examType === 'preTest') {
            return `Pre-Test (${trimmedTitle})`;
        } else if (examType === 'postTest') {
            return `Post-Test (${trimmedTitle})`;
        }
        return trimmedTitle;
    };

    // Extract base title from full title (for editing)
    const extractBaseTitle = (fullTitle, examType) => {
        if (!fullTitle) return '';
        
        const trimmedTitle = fullTitle.trim();
        
        if (examType === 'preTest') {
            if (trimmedTitle.startsWith('Pre-Test (') && trimmedTitle.endsWith(')')) {
                return trimmedTitle.substring(10, trimmedTitle.length - 1);
            }
        } else if (examType === 'postTest') {
            if (trimmedTitle.startsWith('Post-Test (') && trimmedTitle.endsWith(')')) {
                return trimmedTitle.substring(11, trimmedTitle.length - 1);
            }
        }
        return trimmedTitle;
    };

    const handleCreateOrUpdateExam = async () => {
        try {
            setLoading(true);
            setFileError('');
            setExamTypeError('');
            
            // Validation for exam type - must be selected
            if (!formData.examType || formData.examType === 'none' || formData.examType === '') {
                setExamTypeError('Please select either Pre-Test or Post-Test');
                toast.error('Please select either Pre-Test or Post-Test');
                setLoading(false);
                return;
            }

            // Basic validation - only for required fields
            if (!isEditMode && !selectedFile) {
                setFileError('Please upload a questions file');
                toast.error('Please upload a questions file');
                setLoading(false);
                return;
            }

            if (!formData.title?.trim()) {
                toast.error('Exam title is required');
                setLoading(false);
                return;
            }

            // Generate full title with prefix based on exam type
            const fullTitle = generateFullTitle(formData.title, formData.examType);

            // Use FormData for multipart upload
            const formDataToSend = new FormData();
            
            // Create examDTO as JSON string
            const examDTO = {
                id: isEditMode ? formData.id : null,
                title: fullTitle, // Store the full title with prefix
                description: formData.description?.trim() || '20 Questions',
                durationMinutes: parseInt(formData.durationMinutes) || 30,
                maxWarnings: parseInt(formData.maxWarnings) || 3,
                saveLiveVideo: Boolean(formData.saveLiveVideo),
                saveScreenShare: Boolean(formData.saveScreenShare),
                lastAttemptDate: formData.lastAttemptDate,
                batchId: parseInt(formData.batchId),
                status: formData.status,
                examType: formData.examType // Store the exam type
            };

            console.log(`${isEditMode ? 'Updating' : 'Creating'} exam with data:`, examDTO);
            console.log('Generated full title:', fullTitle);

            // Append examDTO as JSON
            formDataToSend.append('examDTO', 
                new Blob([JSON.stringify(examDTO)], {
                    type: 'application/json'
                })
            );

            // Append questions file
            if (selectedFile) {
                formDataToSend.append('questionsFile', selectedFile);
            }

            // Use the helper function for API call
            const response = await fetch(CREATE_EXAM, {
                method: 'POST',
                body: formDataToSend,
            });

            const data = await response.json();

            if (data?.success) {
                toast.success(`Exam ${isEditMode ? 'Updated' : 'Created'} Successfully`);
                setOpenSuccessSnackbar(true);
                fetchExams();
                setOpenCreateDialog(false);
                resetForm();
                setIsEditMode(false);
                setSelectedExamId(null);
            } else {
                throw new Error(data?.message || `Failed to ${isEditMode ? 'update' : 'create'} exam`);
            }

        } catch (error) {
            console.error(`Error ${isEditMode ? 'updating' : 'creating'} exam:`, error);
            let errorMsg = `Failed to ${isEditMode ? 'update' : 'create'} exam`;
            
            if (error.response?.data) {
                if (typeof error.response.data === 'string') {
                    errorMsg = error.response.data;
                } else if (error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
            } else if (error.message) {
                errorMsg = error.message;
            }
            
            if (errorMsg.toLowerCase().includes('excel file has only') || 
                errorMsg.toLowerCase().includes('upload excel with at least')) {
                setFileError(errorMsg);
            }
            
            setErrorMessage(errorMsg);
            setOpenErrorSnackbar(true);
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    // Toggle status with proper error handling
    const handleToggleStatus = async (examId, currentStatus) => {
        if (!examId) {
            toast.error('Invalid exam ID');
            return;
        }

        try {
            setUpdatingStatus(examId);
            
            // Determine new status
            const newStatus = currentStatus === 'locked' ? 'unlocked' : 'locked';
            
            console.log(`Toggling status for exam ${examId} from ${currentStatus} to ${newStatus}`);

            const response = await updateExamStatus(examId, newStatus);

            console.log('Update status response:', response);

            if (response?.success) {
                toast.success(`Status updated to ${newStatus}`);
                
                setExams(prevExams => 
                    prevExams.map(exam => 
                        exam.id === examId 
                            ? { ...exam, status: newStatus }
                            : exam
                    )
                );
            } else if (response?.data?.success) {
                toast.success(`Status updated to ${newStatus}`);
                
                setExams(prevExams => 
                    prevExams.map(exam => 
                        exam.id === examId 
                            ? { ...exam, status: newStatus }
                            : exam
                    )
                );
            } else {
                const errorMsg = response?.data?.message || 
                               response?.message || 
                               'Failed to update status';
                throw new Error(errorMsg);
            }

        } catch (error) {
            console.error('Error toggling status:', error);
            let errorMsg = 'Failed to update status';
            
            if (error.response?.data?.message) {
                errorMsg = error.response.data.message;
            } else if (error.response?.data) {
                if (typeof error.response.data === 'string') {
                    try {
                        const parsed = JSON.parse(error.response.data);
                        errorMsg = parsed.message || errorMsg;
                    } catch {
                        errorMsg = error.response.data;
                    }
                }
            } else if (error.message) {
                errorMsg = error.message;
            }
            
            console.warn(`Status toggle failed for exam ${examId}:`, errorMsg);
            toast.error(`Update failed: ${errorMsg}`);
            
        } finally {
            setUpdatingStatus(null);
        }
    };

    const resetForm = () => {
        setFormData({
            id: null,
            title: '',
            description: '20 Questions', // Default to 20 Questions
            durationMinutes: 30,
            maxWarnings: 3,
            saveLiveVideo: false,
            saveScreenShare: false,
            lastAttemptDate: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
            batchId: params.id,
            status: 'unlocked',
            examType: 'preTest' // Default to preTest
        });
        setSelectedFile(null);
        setFileError('');
        setIsEditMode(false);
        setSelectedExamId(null);
        setDescriptionHelpText('Enter number of questions (e.g., "10", "20", "30")');
        setExamTypeError('');
    };

    const handleEditExam = (exam) => {
        if (!exam) return;
        
        setIsEditMode(true);
        setSelectedExamId(exam.id);
        
        // Convert date array to datetime-local format
        let lastAttemptDate = format(new Date(), "yyyy-MM-dd'T'HH:mm");
        if (exam.lastAttemptDate && Array.isArray(exam.lastAttemptDate) && exam.lastAttemptDate.length >= 5) {
            const [year, month, day, hours, minutes] = exam.lastAttemptDate;
            const date = new Date(year, month - 1, day, hours, minutes);
            lastAttemptDate = format(date, "yyyy-MM-dd'T'HH:mm");
        }
        
        // Extract base title from full title
        const baseTitle = extractBaseTitle(exam.title, exam.examType);
        
        setFormData({
            id: exam.id,
            title: baseTitle, // Set the base title without prefix
            description: exam.description || '20 Questions',
            durationMinutes: exam.durationMinutes || 30,
            maxWarnings: exam.maxWarnings || 3,
            saveLiveVideo: exam.saveLiveVideo || false,
            saveScreenShare: exam.saveScreenShare || false,
            lastAttemptDate: lastAttemptDate,
            batchId: params.id,
            status: exam.status || 'unlocked',
            examType: exam.examType || 'preTest'
        });
        
        console.log('Editing exam:', {
            fullTitle: exam.title,
            baseTitle: baseTitle,
            examType: exam.examType
        });
        
        setSelectedFile(null);
        setFileError('');
        setExamTypeError('');
        setOpenCreateDialog(true);
    };

    const handleFileChange = (event) => {
        const file = event.target.files?.[0] || null;
        setSelectedFile(file);
        setFileError('');
        
        if (file) {
            const validTypes = ['.xlsx', '.xls'];
            const fileExt = '.' + file.name.split('.').pop().toLowerCase();
            
            if (!validTypes.includes(fileExt)) {
                setFileError('Please upload only Excel files (.xlsx, .xls)');
                setSelectedFile(null);
                event.target.value = '';
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        // Handle description change - ensure "Questions" is added if user just types a number
        if (name === 'description') {
            const inputValue = value;
            // If user types just a number, append " Questions"
            if (/^\d+$/.test(inputValue)) {
                setFormData(prev => ({
                    ...prev,
                    description: `${inputValue} Questions`
                }));
                setFileError('');
                return;
            }
            // If user types number followed by anything else, keep as is
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
            setFileError('');
            return;
        }
        
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        
        // Clear exam type error when user selects
        if (name === 'examType') {
            setExamTypeError('');
        }
    };

    const handleProctoringClick = (examId) => {
        if (examId) {
            navigate(`/proctor-dashboard/${examId}`);
        } else {
            toast.error('Invalid exam ID');
        }
    };

    const handleDownloadReport = async (examId) => {
        if (!examId) {
            toast.error('Invalid exam ID');
            return;
        }

        try {
            setLoading(true);

            const authUser = localStorage.getItem('authUser');
            let organizationId = null;

            if (authUser) {
                try {
                    const parsedUser = JSON.parse(authUser);
                    organizationId = parsedUser?.organizationId || null;
                } catch (parseError) {
                    console.error('Error parsing authUser:', parseError);
                }
            }

            const response = await fetch(`${DOWNLOAD_EXAM_REPORT}${examId}`, {
                method: 'GET',
                headers: {
                    "X-Organization-ID": organizationId,
                }
            });

            if (!response.ok) {
                throw new Error('Failed to download report');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exam_report.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
        } catch (error) {
            console.log('Download error:', error);
            toast.error(error?.response?.data?.message || "Failed to download report");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteExam = async (examId) => {
        if (!examId) {
            toast.error('Invalid exam ID');
            return;
        }

        // Check if user has delete permission (same as Attendance component)
        if (!canDeleteExam) {
            toast.error('You do not have permission to delete exams. Only Admin and Project Manager can delete exams.');
            return;
        }

        try {
            setLoading(true);
            const data = await deleteExam(examId);
            if (data?.success) {
                toast.success(data.message || 'Exam deleted successfully');
                fetchExams();
            } else {
                toast.error(data?.message || 'Failed to delete exam');
            }
        } catch (error) {
            console.log('Delete error:', error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    const handleOpenConfirmModal = (examId) => {
        // Check if user has delete permission before opening modal
        if (!canDeleteExam) {
            toast.error('You do not have permission to delete exams. Only Admin and Project Manager can delete exams.');
            return;
        }
        
        if (examId) {
            setExamToDeleteId(examId);
            setOpenConfirmModal(true);
        }
    };

    const handleCloseConfirmModal = () => {
        setOpenConfirmModal(false);
        setExamToDeleteId(null);
    };

    const handleConfirmDelete = () => {
        if (examToDeleteId) {
            handleDeleteExam(examToDeleteId);
        }
        handleCloseConfirmModal();
    };

    const clearSelectedFile = () => {
        setSelectedFile(null);
        setFileError('');
        const fileInput = document.getElementById('questions-file');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const downloadImage = () => {
        const link = document.createElement('a');
        link.href = singleImage;
        link.download = 'exam-qr-code.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Box>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Exams Management
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Create and manage exams for this batch
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<Image />}
                        onClick={() => setOpenImageDialog(true)}
                        disabled={loading}
                        size="large"
                        sx={{
                            textTransform: 'none',
                            fontWeight: 500
                        }}
                    >
                        View Exam QR
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Add />}
                        onClick={() => {
                            resetForm();
                            setOpenCreateDialog(true);
                        }}
                        disabled={loading}
                        size="large"
                    >
                        Create New Exam
                    </Button>
                </Box>
            </Box>

            {/* Permission Info Card - Same style as Attendance component */}
            <Paper sx={{ p: 2, mb: 3, bgcolor: 'info.light', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="subtitle2" component="div" color="info.dark">
                            <strong>User Role:</strong> {userType || 'Loading...'}
                        </Typography>
                        <Typography variant="caption" component="div" color="info.dark">
                            <strong>Permissions:</strong> 
                            {canDeleteExam ? ' ✅ Can delete exams' : ' ❌ Cannot delete exams'}
                            {canDeleteExam && ' (Admin & Project Manager only)'}
                        </Typography>
                    </Box>
                    {!canDeleteExam && (
                        <Chip 
                            label="Read Only Mode" 
                            color="warning" 
                            size="small"
                        />
                    )}
                </Box>
            </Paper>

            {/* Info Card */}
            <Paper sx={{ p: 3, mb: 3, bgcolor: 'info.light', color: 'info.contrastText' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <Info />
                    <Typography variant="subtitle1" fontWeight="bold">
                        How it works:
                    </Typography>
                </Box>
                <Typography variant="body2">
                    • <strong>Exam Type:</strong> Must select either Pre-Test or Post-Test from dropdown (mandatory)<br/>
                    • Description automatically adds "Questions" - just type the number (e.g., "10", "20", "30")<br/>
                    • Upload Excel file with questions (can have more questions than needed)<br/>
                    • System will randomly select the required number of questions from Excel<br/>
                    • <strong>Status:</strong> Click on status chip to toggle between Locked/Unlocked<br/>
                    • <strong>Delete Access:</strong> Only Admin and Project Manager can delete exams<br/>
                    • <strong>Click "View Image" button to see the exam QR code/image</strong>
                </Typography>
            </Paper>

            {loading && !exams.length ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                    <CircularProgress size={60} />
                </Box>
            ) : (
                <TableContainer component={Paper} elevation={3}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ bgcolor: 'primary.main' }}>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Title</TableCell>
                                {/* <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Type</TableCell> */}
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Description</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Questions</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Duration (mins)</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Last Attempt Date</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Proctoring</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Report</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(exams) && exams.length > 0 ? (
                                exams.map((exam) => {
                                    const questionInfo = getQuestionInfo(exam.description);
                                    const statusInfo = getStatusInfo(exam.status);
                                    const examTypeInfo = getExamTypeInfo(exam.examType);
                                    const isUpdating = updatingStatus === exam.id;
                                    
                                    return (
                                        <TableRow 
                                            key={exam.id}
                                            hover
                                            sx={{ 
                                                '&:hover': { bgcolor: 'action.hover' },
                                                '&:last-child td, &:last-child th': { border: 0 }
                                            }}
                                        >
                                            <TableCell>
                                                <Typography fontWeight="medium">{exam.title || 'N/A'}</Typography>
                                            </TableCell>
                                            {/* <TableCell>
                                                <Chip 
                                                    label={examTypeInfo.label}
                                                    color={examTypeInfo.color}
                                                    size="small"
                                                    icon={<span>{examTypeInfo.icon}</span>}
                                                />
                                            </TableCell> */}
                                            <TableCell>
                                                <Typography variant="body2" sx={{ maxWidth: '200px' }}>
                                                    {exam.description || 'No description'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Chip 
                                                    label={questionInfo.text}
                                                    color={questionInfo.count ? "primary" : "default"}
                                                    size="small"
                                                    variant="outlined"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title={`Click to toggle status. Current: ${statusInfo.label}`}>
                                                    <Box sx={{ display: 'inline-block' }}>
                                                        <Chip 
                                                            icon={isUpdating ? <SwapVert fontSize="small" /> : statusInfo.icon}
                                                            label={isUpdating ? 'Updating...' : statusInfo.label}
                                                            color={statusInfo.color}
                                                            size="small"
                                                            variant="filled"
                                                            onClick={() => handleToggleStatus(exam.id, exam.status)}
                                                            disabled={isUpdating}
                                                            sx={{
                                                                fontWeight: 'medium',
                                                                '& .MuiChip-icon': {
                                                                    ml: 0.5
                                                                },
                                                                cursor: isUpdating ? 'default' : 'pointer',
                                                                '&:hover:not(:disabled)': {
                                                                    opacity: 0.9,
                                                                    transform: 'scale(1.05)',
                                                                    transition: 'transform 0.2s'
                                                                }
                                                            }}
                                                        />
                                                    </Box>
                                                </Tooltip>
                                                {exam.status === 'locked' && (
                                                    <Typography variant="caption" color="error" sx={{ ml: 1, display: 'block', mt: 0.5 }}>
                                                        Students cannot access this exam
                                                    </Typography>
                                                )}
                                                {exam.status === 'unlocked' && (
                                                    <Typography variant="caption" color="success" sx={{ ml: 1, display: 'block', mt: 0.5 }}>
                                                        Students can access this exam
                                                    </Typography>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <Chip 
                                                    label={`${exam.durationMinutes || 'N/A'} mins`}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2">
                                                    {formatExamDate(exam.lastAttemptDate)}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title="Open proctoring dashboard">
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        startIcon={<Visibility />}
                                                        onClick={() => handleProctoringClick(exam.id)}
                                                        sx={{
                                                            textTransform: 'none',
                                                            fontSize: '0.875rem'
                                                        }}
                                                    >
                                                        Proctor
                                                    </Button>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title="Download exam report">
                                                    <Button
                                                        variant="outlined"
                                                        color="secondary"
                                                        size="small"
                                                        startIcon={<Download />}
                                                        onClick={() => handleDownloadReport(exam.id)}
                                                        sx={{
                                                            textTransform: 'none',
                                                            fontSize: '0.875rem'
                                                        }}
                                                    >
                                                        Report
                                                    </Button>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <Tooltip title="Edit exam">
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            size="small"
                                                            startIcon={<Edit />}
                                                            onClick={() => handleEditExam(exam)}
                                                            sx={{
                                                                textTransform: 'none',
                                                                fontSize: '0.875rem'
                                                            }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip title={canDeleteExam ? "Delete exam" : "Only Admin and Project Manager can delete exams"}>
                                                        <span>
                                                            <Button
                                                                variant="outlined"
                                                                color="error"
                                                                size="small"
                                                                startIcon={<Delete />}
                                                                onClick={() => handleOpenConfirmModal(exam.id)}
                                                                disabled={!canDeleteExam}
                                                                sx={{
                                                                    textTransform: 'none',
                                                                    fontSize: '0.875rem'
                                                                }}
                                                            >
                                                                Delete
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Typography variant="h6" color="text.secondary" gutterBottom>
                                                No exams found
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                                Create your first exam by clicking the "Create New Exam" button
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<Add />}
                                                onClick={() => {
                                                    resetForm();
                                                    setOpenCreateDialog(true);
                                                }}
                                                sx={{ mt: 2 }}
                                            >
                                                Create First Exam
                                            </Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    
                    {/* Confirm Delete Dialog */}
                    <Dialog
                        open={openConfirmModal}
                        onClose={handleCloseConfirmModal}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Confirm Deletion"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure you want to delete this exam? This action cannot be undone and will delete all related data including student attempts.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseConfirmModal} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={handleConfirmDelete} color="error" variant="contained" autoFocus>
                                Delete Exam
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TableContainer>
            )}

            {/* Image Popup Dialog */}
            <Dialog
                open={openImageDialog}
                onClose={() => setOpenImageDialog(false)}
                maxWidth="md"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxHeight: '90vh',
                        margin: 0
                    }
                }}
            >
                <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6">
                            Exam QR Code / Image
                        </Typography>
                        <IconButton 
                            onClick={() => setOpenImageDialog(false)}
                            sx={{ color: 'white' }}
                        >
                            <Close />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers sx={{ pt: 3 }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Card sx={{ maxWidth: 500, mx: 'auto', mb: 3 }}>
                            <CardMedia
                                component="img"
                                image={singleImage}
                                alt="Exam QR Code"
                                sx={{ 
                                    width: '100%', 
                                    height: 'auto',
                                    maxHeight: 400,
                                    objectFit: 'contain',
                                    p: 2
                                }}
                            />
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Exam QR Code
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    This QR code/image is common for all exams. Students can scan this code to access their exams.
                                </Typography>
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                        • Share this image with students<br/>
                                        • Print for classroom display<br/>
                                        • Include in exam instructions
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>

                        {/* Instructions */}
                        <Paper sx={{ p: 3, mb: 3, bgcolor: 'grey.50' }}>
                            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                                How to use:
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                1. <strong>For Students:</strong> Scan the QR code with a mobile device camera or QR scanner app
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                2. <strong>For Instructors:</strong> Display this image during exam sessions for easy access
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph>
                                3. <strong>For Printed Materials:</strong> Include this QR code in exam handouts and announcements
                            </Typography>
                            <Alert severity="info" sx={{ mt: 2 }}>
                                <Typography variant="body2">
                                    <strong>Note:</strong> This is a common QR code for all exams. It provides quick access to the exam portal.
                                </Typography>
                            </Alert>
                        </Paper>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: 'grey.50' }}>
                    <Button 
                        onClick={() => setOpenImageDialog(false)}
                        color="inherit"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Create/Edit Exam Dialog */}
            <Dialog
                open={openCreateDialog}
                onClose={() => {
                    setOpenCreateDialog(false);
                    resetForm();
                }}
                fullWidth
                maxWidth="md"
                sx={{
                    '& .MuiDialog-paper': {
                        maxHeight: '90vh',
                        margin: 0,
                        overflowY: 'auto'
                    }
                }}
            >
                <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6">
                            {isEditMode ? 'Edit Exam' : 'Create New Exam'}
                        </Typography>
                        <IconButton 
                            onClick={() => {
                                setOpenCreateDialog(false);
                                resetForm();
                            }}
                            sx={{ color: 'white' }}
                        >
                            <Close />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers sx={{ pt: 3 }}>
                    <Box component="form" sx={{ mt: 1 }}>
                        {/* Exam Title */}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Exam Title"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            variant="outlined"
                            size="small"
                            helperText={formData.examType && formData.examType !== 'none' && formData.examType !== '' ? 
                                `Full title will be: ${generateFullTitle(formData.title, formData.examType)}` : 
                                'Enter the base title for the exam'}
                        />
                        
                        {/* Exam Type Dropdown - Mandatory */}
                        <Box sx={{ mt: 3, mb: 2 }}>
                            <FormControl fullWidth margin="normal" size="small" error={!!examTypeError}>
                                <InputLabel id="exam-type-label">Exam Type <span style={{ color: 'red' }}>*</span></InputLabel>
                                <Select
                                    labelId="exam-type-label"
                                    id="exam-type-select"
                                    name="examType"
                                    value={formData.examType}
                                    onChange={handleInputChange}
                                    label="Exam Type *"
                                    variant="outlined"
                                >
                                    <MenuItem value="preTest">
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <span>📝</span>
                                            <Typography>Pre-Test</Typography>
                                            <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                                (Adds "Pre-Test" prefix)
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                    <MenuItem value="postTest">
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <span>📋</span>
                                            <Typography>Post-Test</Typography>
                                            <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                                (Adds "Post-Test" prefix)
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                </Select>
                                {examTypeError && (
                                    <FormHelperText error>{examTypeError}</FormHelperText>
                                )}
                                {!examTypeError && formData.examType && formData.examType !== 'none' && formData.examType !== '' && (
                                    <FormHelperText sx={{ color: 'success.main' }}>
                                        ✓ {formData.examType === 'preTest' ? 'Pre-Test' : 'Post-Test'} selected
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                        
                        {/* Description - Auto adds "Questions" */}
                        <TextField
                            margin="normal"
                            fullWidth
                            label="Number of Questions"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder='Enter number only (e.g., "10", "20", "30")'
                            helperText={
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        {descriptionHelpText}
                                    </Typography>
                                    <br />
                                    <Typography variant="caption" color="info.main">
                                        💡 Just type the number - "Questions" will be added automatically
                                    </Typography>
                                </Box>
                            }
                            variant="outlined"
                            size="small"
                        />
                        
                        {/* Status Selector */}
                        <Box sx={{ mt: 2, mb: 2 }}>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Exam Status</InputLabel>
                                <Select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                    label="Exam Status"
                                    variant="outlined"
                                >
                                    <MenuItem value="unlocked">Unlocked (Students can access)</MenuItem>
                                    <MenuItem value="locked">Locked (Students cannot access)</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        
                        {/* Duration and Warnings */}
                        <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                            <TextField
                                margin="normal"
                                required
                                label="Duration (minutes)"
                                name="durationMinutes"
                                type="number"
                                value={formData.durationMinutes}
                                onChange={handleInputChange}
                                sx={{ minWidth: '200px', flex: 1 }}
                                variant="outlined"
                                size="small"
                            />
                            <TextField
                                margin="normal"
                                required
                                label="Max Warnings"
                                name="maxWarnings"
                                type="number"
                                value={formData.maxWarnings}
                                onChange={handleInputChange}
                                sx={{ minWidth: '200px', flex: 1 }}
                                variant="outlined"
                                size="small"
                            />
                        </Box>
                        
                        {/* Last Attempt Date */}
                        <Box sx={{ mt: 2 }}>
                            <TextField
                                label="Last Attempt Date & Time"
                                type="datetime-local"
                                name="lastAttemptDate"
                                value={formData.lastAttemptDate}
                                onChange={handleInputChange}
                                fullWidth
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                                size="small"
                            />
                        </Box>
                        
                        {/* Proctoring Options - Fixed dropdown labels */}
                        <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Save Live Video</InputLabel>
                                <Select
                                    name="saveLiveVideo"
                                    value={formData.saveLiveVideo}
                                    onChange={handleInputChange}
                                    label="Save Live Video"
                                    variant="outlined"
                                >
                                    <MenuItem value={true}>Yes - Save video recording</MenuItem>
                                    <MenuItem value={false}>No - Don't save video</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Save Screen Share</InputLabel>
                                <Select
                                    name="saveScreenShare"
                                    value={formData.saveScreenShare}
                                    onChange={handleInputChange}
                                    label="Save Screen Share"
                                    variant="outlined"
                                >
                                    <MenuItem value={true}>Yes - Save screen recording</MenuItem>
                                    <MenuItem value={false}>No - Don't save screen</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        
                        {/* File Upload */}
                        <Box sx={{ mt: 2, p: 2, border: '1px dashed', borderColor: fileError ? 'error.main' : 'grey.400', borderRadius: 1 }}>
                            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                                {isEditMode ? 'Upload New Questions (Optional)' : 'Upload Questions (Excel File - Required)'}
                            </Typography>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    size="small"
                                    startIcon={<Add />}
                                >
                                    Choose Excel File
                                    <input
                                        accept=".xlsx,.xls"
                                        id="questions-file"
                                        type="file"
                                        onChange={handleFileChange}
                                        hidden
                                        required={!isEditMode}
                                    />
                                </Button>
                                
                                {selectedFile && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Chip 
                                            label={selectedFile.name}
                                            onDelete={clearSelectedFile}
                                            color="primary"
                                            variant="outlined"
                                        />
                                        <Typography variant="body2" color="text.secondary">
                                            ({Math.round(selectedFile.size / 1024)} KB)
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                            
                            {fileError && (
                                <Alert severity="error" sx={{ mt: 2 }}>
                                    {fileError}
                                </Alert>
                            )}
                            
                            {!selectedFile && !isEditMode && (
                                <Alert severity="warning" sx={{ mt: 2 }}>
                                    Please select an Excel file (.xlsx, .xls) containing questions
                                </Alert>
                            )}
                            
                            {isEditMode && !selectedFile && (
                                <Alert severity="info" sx={{ mt: 2 }}>
                                    No file selected. Existing questions will be retained.
                                </Alert>
                            )}
                            
                            <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
                                <strong>Excel Format:</strong> Columns should include: Question, Option1, Option2, Option3, Option4, CorrectAnswer (1-4)
                            </Typography>
                            
                            {!isEditMode && (
                                <Alert severity="info" sx={{ mt: 2 }}>
                                    <strong>Note:</strong> System will randomly select questions from Excel based on description count.<br/>
                                    Example: Description "20 Questions" + Excel with 50 questions = 20 random questions saved
                                </Alert>
                            )}
                            
                            {isEditMode && (
                                <Alert severity="info" sx={{ mt: 2 }}>
                                    <strong>Note:</strong> Upload new Excel file only if you want to change questions. 
                                    System will randomly select questions based on new description count.
                                </Alert>
                            )}
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: 'grey.50' }}>
                    <Button 
                        onClick={() => {
                            setOpenCreateDialog(false);
                            resetForm();
                        }}
                        color="inherit"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleCreateOrUpdateExam}
                        variant="contained"
                        color="primary"
                        disabled={loading || !formData.title.trim() || (!isEditMode && !selectedFile) || !formData.examType || formData.examType === 'none' || formData.examType === ''}
                        startIcon={loading ? <CircularProgress size={20} /> : null}
                    >
                        {loading ? 'Processing...' : (isEditMode ? 'Update Exam' : 'Create Exam')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Success Snackbar */}
            <Snackbar
                open={openSuccessSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSuccessSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert 
                    onClose={() => setOpenSuccessSnackbar(false)} 
                    severity="success" 
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {isEditMode ? '✓ Exam updated successfully!' : '✓ Exam created successfully!'}
                </Alert>
            </Snackbar>

            {/* Error Snackbar */}
            <Snackbar
                open={openErrorSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenErrorSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert 
                    onClose={() => setOpenErrorSnackbar(false)} 
                    severity="error" 
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {errorMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default ExamList;